import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';

interface Toast {
  id: number;
  tone: 'ok' | 'error' | 'info';
  text: ReactNode;
}

const Ctx = createContext<(tone: Toast['tone'], text: ReactNode) => void>(() => {});
let seq = 0;

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toasts, setToasts] = useState<Toast[]>([]);
  const push = useCallback((tone: Toast['tone'], text: ReactNode) => {
    const id = ++seq;
    setToasts((all) => [...all.slice(-3), { id, tone, text }]);
    setTimeout(() => setToasts((all) => all.filter((x) => x.id !== id)), tone === 'error' ? 9000 : 6000);
  }, []);
  return (
    <Ctx.Provider value={push}>
      {children}
      <div className="toasts" role="status" aria-live="polite">
        {toasts.map((t) => (
          <div key={t.id} className={`toast ${t.tone}`} data-seq={t.id}>
            {t.text}
          </div>
        ))}
      </div>
    </Ctx.Provider>
  );
}

export const useToast = () => useContext(Ctx);
